export const SWITCH_LANG = "SWITCH_LANG";
export const SWITCH_THEME = "SWITCH_THEME";
